module.exports = __webpack_public_path__ + "static/accpanelwording-58ef8f33959adb86bdd1cd187c28045d.png";